import tableStyles from "@/_styles/table.module.scss"

import { ICustomer } from "@/types/ICustomer"
import { ITableColumn } from "@/types/ui"

import { getMoney } from "@/utils/formatNumber"



export const customerColumns: ITableColumn<ICustomer>[] = [
  {
    title: "Код контрагента",
    key: "id",
    dataIndex: ["id"],
    //render: (_, { id }) => <span className={tableStyles["text-gray"]}>{ id }</span>,
    align: "center",
    sorter: true,
    isVisible: false,
    order: 1
  },
  {
    title: "Клиент",
    key: "customerClientName",
    dataIndex: ["customerClientName"],
    //render: (_, { customerClientName }) => <span className={tableStyles["text-gray"]}>{ customerClientName }</span>,
    align: "center",
    sorter: true,
    isVisible: true,
    order: 2
  },
  {
    title: "Контрагент",
    key: "name",
    dataIndex: ["name"],
    align: "center",
    //render: (_, { name }) => <span className={tableStyles["text-gray"]}>{ name }</span>,
    sorter: true,
    defaultSortOrder: "ascend",
    isVisible: true,
    order: 3
  },
  {
    title: "Баланс",
    key: "balance",
    dataIndex: ["balance"],
    render: (_, { balance }) => <span className={tableStyles["text-summ"]}>{getMoney(balance)}</span>,
    align: "center",
    sorter: true,
    isVisible: false,
    order: 4
  },
  {
    title: "Сумма заказов в работе",
    key: "sumOrder",
    dataIndex: ["sumOrder"],
    render: (_, { sumOrder }) => <span className={tableStyles["text-summ"]}>{getMoney(sumOrder)}</span>,
    align: "center",
    sorter: true,
    isVisible: false,
    order: 5
  },
  {
    title: "Сумма оплаченных заказов в работе",
    key: "paidOrderSum",
    dataIndex: ["paidOrderSum"],
    render: (_, { paidOrderSum }) => <span className={tableStyles["text-summ"]}>{getMoney(paidOrderSum)}</span>,
    align: "center",
    sorter: true,
    isVisible: false,
    order: 6
  },
  {
    title: "Сумма доступная для заказа",
    key: "availableSum",
    dataIndex: ["availableSum"],
    render: (_, { availableSum }) => <span className={tableStyles["text-summ"]}>{getMoney(availableSum)}</span>,
    align: "center",
    sorter: true,
    isVisible: false,
    order: 7
  },
  {
    title: "Дневной лимит",
    key: "dayLimit",
    dataIndex: ["dayLimit"],
    render: (_, { dayLimit }) => <span className={tableStyles["text-bold"]}>{ dayLimit }</span>,
    align: "center",
    sorter: true,
    isVisible: false,
    order: 8
  },
  {
    title: "Телефон",
    key: "phone",
    dataIndex: ["phone"],
    align: "center",
    render: (_, customer: ICustomer) => <span className={tableStyles["text-gray"]}>{ customer.phone ? `+7 ${customer.phone}` : "-" }</span>,
    sorter: true,
    isVisible: true,
    order: 9
  },
  {
    title: "ИНН",
    key: "inn",
    dataIndex: ["inn"],
    //render: (_, { inn }) => <span className={tableStyles["text-gray"]}>{ inn }</span>,
    align: "center",
    sorter: true,
    isVisible: true,
    order: 10
  },
  {
    title: "ОГРН",
    key: "ogrn",
    dataIndex: ["ogrn"],
    //render: (_, { ogrn }) => <span className={tableStyles["text-gray"]}>{ ogrn }</span>,
    align: "center",
    sorter: true,
    isVisible: true,
    order: 11
  }
]